/**
 * Rounds the number towards 0.
 */
export default (n: number): number => n >= 0 ? Math.floor(n) : Math.ceil(n)
